import React, { memo } from "react";

const TradePairsSection = (props) => {
    const {
        CoinPairDetails,
        SelectedCoin,
        coinFilter,
        coinIconSrc,
        favCoins,
        handleAddFav,
        handleSelectCoin,
        isFavouritesOpen,
        setIsFavouritesOpen,
        search,
        setcoinFilter,
        setsearch,
        token,
        closeOnLeave = true,
        title,
        onClose,
        hideQuoteTabs = false,
    } = props;

    return (
        <>
            <div
                className={`col-12 col-lg-12 col-xl-2 col-xxl-2 trade_favourites_lft ${isFavouritesOpen ? "is-open" : "is-collapsed"}`}
                onMouseEnter={closeOnLeave ? () => setIsFavouritesOpen(true) : undefined}
                onMouseLeave={closeOnLeave ? () => setIsFavouritesOpen(false) : undefined}
            >
                <div className="spotLists">
                    {(title || onClose) && (
                        <div className="trade_pairs_drawer_header">
                            <span className="trade_pairs_drawer_title">{title || "Select Trading Pair"}</span>
                            {onClose && (
                                <button
                                    type="button"
                                    className="trade_pairs_drawer_close"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onClose();
                                    }}
                                    aria-label="Close"
                                >
                                    <i className="ri-close-line" />
                                </button>
                            )}
                        </div>
                    )}

                    {/* Search */}
                    <div className="spot-list-search">
                        <div className="ivu-input">
                            <i className="ri-search-2-line"></i>
                            <input
                                autoComplete="off"
                                spellCheck="false"
                                type="search"
                                placeholder="Search"
                                onChange={(e) => setsearch(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>

                    {!hideQuoteTabs ? (
                    <ul className="favorites_list_tabs">
                        {token && (
                            <li>
                                <button
                                    className={coinFilter === 'FAV' ? 'active' : ''}
                                    onClick={() => setcoinFilter('FAV')}
                                >
                                    Favourites
                                </button>
                            </li>
                        )}
                        {CoinPairDetails && [...new Set([
                            ...CoinPairDetails.map((item) => item?.quote_currency).filter(Boolean),
                            "BTC",
                            "BNB",
                            "ETH",
                        ])].map((quoteCurrency) => (
                            <li key={quoteCurrency}>
                                <button
                                    className={coinFilter === quoteCurrency ? 'active' : ''}
                                    onClick={() => setcoinFilter(quoteCurrency)}
                                >
                                    {quoteCurrency}
                                </button>
                            </li>
                        ))}
                    </ul>
                    ) : null}

                    {/* Table */}
                    <div className="price_card table-responsive">
                        <table className="table table-sm table-borderless mb-0 orderbook-table">
                            <thead>
                                <tr>
                                    <th>Pair</th>
                                    <th className="text-end">Price</th>
                                    <th className="text-end">Change</th>
                                </tr>
                            </thead>

                            <tbody className="price_card_body">

                                {/* ALL TAB */}
                                {CoinPairDetails &&
                                    CoinPairDetails.map((data, index) => {
                                        // Filter by favorites
                                        if (!hideQuoteTabs && coinFilter === "FAV" && !favCoins.includes(data?._id)) {
                                            return null;
                                        }
                                        if (!hideQuoteTabs && coinFilter !== "FAV" && (data?.quote_currency !== coinFilter && data?.base_currency !== coinFilter)) {
                                            return null;
                                        }


                                        const isActive =
                                            SelectedCoin?.base_currency === data?.base_currency &&
                                            SelectedCoin?.quote_currency === data?.quote_currency;

                                        return (
                                            <tr
                                                key={index}
                                                className={isActive ? "active" : ""}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleSelectCoin(data)}

                                            >
                                                {/* Pair */}
                                                <td>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <img
                                                            src={coinIconSrc(data?.icon_path)}
                                                            alt=""
                                                            className="img-fluid me-1 round_img"
                                                        />
                                                        <div className="d-flex flex-column pair-color">
                                                            {`${data?.base_currency}/${data?.quote_currency}`}
                                                            <span className="tokensubcnt">{data?.base_currency_fullname}</span>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Price */}
                                                <td className="text-end">
                                                    <div className="d-flex flex-column  pair-color">
                                                        <span>{data?.buy_price}</span>
                                                        <span className="tokensubcnt">${data?.buy_price}</span>
                                                    </div>
                                                </td>

                                                {/* Change + Star */}
                                                <td className="text-end">
                                                    <div className="d-flex justify-content-end align-items-center gap-2">
                                                        <div className="d-flex flex-column  pair-color text-end">
                                                            <span
                                                                className={
                                                                    data?.change_percentage >= 0
                                                                        ? "text-green"
                                                                        : "text-danger"
                                                                }
                                                            >
                                                                {data?.change_percentage >= 0 ? `+${Number(parseFloat(data?.change_percentage)?.toFixed(5))}` : Number(parseFloat(data?.change_percentage)?.toFixed(5))}%
                                                            </span>
                                                            <span className="tokensubcnt">{parseFloat(data?.change?.toFixed(5)) || 0}</span>
                                                        </div>

                                                        {token && (
                                                            <i
                                                                className={
                                                                    favCoins.includes(data?._id)
                                                                        ? "ri ri-star-fill ri-xl"
                                                                        : "ri ri-star-line ri-xl"
                                                                }
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleAddFav(data?._id);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    );
};

export default memo(TradePairsSection);
